import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const GetEvents = createAsyncThunk(
    '/GetEvents',
    async () => {
        let url = baseUrl+'GetEvents';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
        console.log(response);
       
        if(response.data.status === "succes"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );




  


  